import { ReactComponent as AllBonusesSvg } from './assets/images/all-bonuses.svg';
import { ReactComponent as HistorySvg } from './assets/images/history.svg';

export const eventsBonusesList = [
  { label: 'bonuses.all', icon: AllBonusesSvg, value: 'all_bonuses' },
  { label: 'bonuses.history', icon: HistorySvg, value: 'history' },
];
